import { Form, Formik } from "formik";
import React, { useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import "./addproduct.css";
import { ExampleImageOne, ExampleImageTwo, FeatherImg } from "assets/images";
import CustomModal from "components/Modal/CustomModal";
import { Carousel, Spinner } from "react-bootstrap";
import ProfileContext from "context/ProfileContext";
import { TrashFill } from "react-bootstrap-icons";

const UploadMediaPage = (props) => {
  let { putToS3 } = useContext(ProfileContext);
  const [isEnabled, setIsEnabled] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [imagefiles, setImageFiles] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleImageFilesChange = (updatedFiles) => {
    setImageFiles([...updatedFiles]);
    setIsEnabled(updatedFiles.length >= 1);
  };

  const handleVideoFilesChange = (updatedFiles) => {
    setVideoFiles([...updatedFiles]);
  };

  const handleSubmit = (values) => {
    if (isEnabled === true) {
      setIsEnabled(false);
      setLoading(true);
      const first = Promise.all(
        values?.files?.map(async (e) => {
          let res = await putToS3({
            tag: "product photo",
            type: "image",
            extension: "jpeg",
            file: [e],
          });
          return res.data.data.id;
        })
      );

      const second = Promise.all(
        values?.videos?.map(async (e) => {
          let res = await putToS3({
            tag: "product video",
            type: "video",
            extension: "mp4",
            file: [e],
          });
          return res.data.data.id;
        })
      );

      const promise = Promise.all([first, second]);
      promise
        .then((data) => {
          setIsEnabled(true);
          setLoading(false);
          values.productPictureId = data[0];
          values.productVideoId = data[1];
          props.next(values);
        })
        .catch((err) => {
          // Re-enable so user can retry
          setIsEnabled(imagefiles.length >= 1);
          setLoading(false);
        });
    }
  };

  return (
    <Formik initialValues={props.data} onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <div className="product-form-wrapper">
            <div className="product-information-wrapper">
              <h3 className="text-start">Media Upload</h3>
              <p className="text-start">
                Follow the instructions and upload your media to be verified.
              </p>
            </div>

            <div className="product-uploader">
              <div className="row align-items-start">

                
                <div className="col-md-6 col-sm-12 image-uploader mb-2">
                  <div className="form-group h-100">
                    
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span
                        style={{
                          color: "#dc3545",
                          fontWeight: 700,
                          fontSize: "13px",
                        }}
                      >
                        ★ Required
                      </span>
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6c757d",
                        }}
                      >
                        At least 1 photo must be uploaded
                      </span>
                    </div>

                    <UploadComponent
                      files={imagefiles}
                      class="uploader-part"
                      image={FeatherImg}
                      
                      title={
                        <span>
                          Upload a photo of your product{" "}
                          <span style={{ color: "#dc3545" }}>*</span>
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#6c757d",
                              fontWeight: 400,
                              display: "block",
                            }}
                          >
                            (Limit of 5)
                          </span>
                        </span>
                      }
                      footer="JPG, PNG, GIF · max 10MB each"
                      accept={{ "image/*": [] }}
                      maxSize={10000000}
                      
                      onFilesChange={handleImageFilesChange}
                    />
                  </div>
                </div>

                
                <div className="col-md-6 col-sm-12 mb-2 video-uploader">
                  <div className="form-group h-100" style={{ display: "flex", flexDirection: "column" }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span
                        style={{
                          color: "#198754",
                          fontWeight: 700,
                          fontSize: "13px",
                        }}
                      >
                        Optional
                      </span>
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6c757d",
                        }}
                      >
                        Video is not required but recommended
                      </span>
                    </div>

                    <UploadComponent
                      files={videoFiles}
                      class="uploader-part-video"
                      image={FeatherImg}
                      title="Upload a short video of your product (Limit of 5)"
                      footer="MP4 · 1–3 minutes · max 50MB"
                      accept={{ "video/*": [] }}
                      maxSize={50000000}
                      onFilesChange={handleVideoFilesChange}
                    />
                  </div>
                </div>

                
                {loading && (
                  <div className="d-flex justify-content-center">
                    Uploading{" "}
                    <div className="spinner-dots">
                      <Spinner className="custom-blink" animation="grow" />
                      <Spinner className="custom-blink" animation="grow" />
                      <Spinner className="custom-blink" animation="grow" />
                    </div>
                  </div>
                )}

                
                <div className="example-wrapper-photos mt-3">
                  <p className="example-text-blip" onClick={handleShow}>
                    See examples
                  </p>
                  <CustomModal
                    showStatus={show}
                    clickStatus={handleClose}
                    buttonMessage="Close"
                    closeStatus={handleClose}
                    title="Photo"
                    message={
                      <div className="good-bad-photo-viewer">
                        <Carousel>
                          <Carousel.Item interval={2000}>
                            <img
                              className="d-block w-100"
                              src={ExampleImageOne}
                              alt="First slide"
                            />
                          </Carousel.Item>
                          <Carousel.Item interval={2000}>
                            <img
                              className="d-block w-100"
                              src={ExampleImageTwo}
                              alt="Second slide"
                            />
                          </Carousel.Item>
                        </Carousel>
                      </div>
                    }
                    secondMessage="none"
                    secondButton={false}
                  />
                </div>
              </div>
            </div>
          </div>

          
          <div className="button-wrapper-product text-end">
            
            <div
              // disabled={!isEnabled}
              // type="submit"
              onClick={() => {
                if (!isEnabled) return; 
                setFieldValue(`files`, imagefiles);
                setFieldValue(`videos`, videoFiles);
                setShowConfirmation(true);
              }}
              className={`btn ${
                isEnabled ? "btn-outline-primary" : "btn-secondary"
              }`}
              style={{
                cursor: isEnabled ? "pointer" : "not-allowed",
                opacity: isEnabled ? 1 : 0.55,
              }}
              title={
                !isEnabled
                  ? "Please upload at least 1 product photo to continue"
                  : ""
              }
            >
              Next
            </div>

            
            <CustomModal
              showStatus={showConfirmation}
              clickStatus={() => setShowConfirmation(false)}
              buttonMessage="Close"
              closeStatus={() => setShowConfirmation(false)}
              title="Confirm media?"
              message={
                <div className="confirmation">
                  Are you sure about your uploaded media? You will have to
                  re-do the process if you change your mind after this step.
                </div>
              }
              secondMessage="ConfirmUpload"
              secondButton={true}
              loading={loading}
              setLoading={setLoading}
              submitActionProduct={() => {
                handleSubmit(values);
                setShowConfirmation(false);
              }}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

const UploadComponent = (props) => {
  const { files } = props;
  const [errors, setErrors] = useState("");
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: props.accept,
    maxFiles: 5,
    multiple: true,
    maxSize: props.maxSize,
    onDrop: (acceptedFiles, fileRejections) => {
      if (acceptedFiles.length > 0) {
        const remaining = 5 - files.length;
        if (remaining <= 0) {
          setErrors("Maximum upload reached");
          return;
        }
        
        const toAdd = acceptedFiles.slice(0, remaining);
        const updated = [...files, ...toAdd];
        setErrors(updated.length >= 5 ? "Maximum upload reached" : "");
        props.onFilesChange(updated);
      }

      if (fileRejections.length > 0) {
        fileRejections.forEach((file) => {
          file.errors.forEach((err) => {
            if (err.code === "file-too-large") {
              setErrors(`Error: File is larger than acceptable`);
            }

            if (err.code === "file-invalid-type") {
              setErrors(`Error: ${err.message}`);
            }
          });
        });
      }
    },
  });
  
  const handleDelete = (index) => {
    const updated = files.filter((_, i) => i !== index);
    setErrors(updated.length >= 5 ? "Maximum upload reached" : "");
    props.onFilesChange(updated);
  };

  return (
    <div>
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <div className={`${props.class} text-center`}>
            <div className="upload-text justify-content-center">
              <h5 className="title">Drop the files here ...</h5>
              <div className="bottom-wrapper">
                <img className="upload-icon" src={FeatherImg} alt="upload" />
              </div>
            </div>
          </div>
        ) : (
          <div className={`${props.class} text-center`}>
            <div className="upload-text justify-content-center">
              <h5 className="title">{props.title}</h5>
              <ul
                className="text"
                style={{ listStyle: "none", padding: 0, margin: "8px 0", width: "100%" }}
              >
                {files.map((e, i) => (
                  <li
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "4px 8px",
                      marginBottom: "4px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "6px",
                      fontSize: "12px",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1,
                        textAlign: "left",
                      }}
                    >
                      {e.name}
                    </span>
                    <span
                      onClick={(ev) => {
                        ev.stopPropagation();
                        handleDelete(i);
                      }}
                      style={{ cursor: "pointer", flexShrink: 0 }}
                    >
                      <TrashFill color="#f04b4b" size={13} />
                    </span>
                  </li>
                ))}
              </ul>
              {errors && <p style={{ color: "red" }}>{errors}</p>}
              <div className="bottom-wrapper">
                <img className="upload-icon" src={props.image} alt="upload" />
                <p>{props.footer}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadMediaPage;
